import React, { useEffect, useState, useRef } from 'react';
import './search-results.m.css';
import SearchIcon from '../../../atoms/icons/search';
import CardWithAuthorDateTimeHeadline from '../../../molecules/card-with-author-date-time-headline';
import Button from '../../../atoms/button';
import { DownArrow } from '../../../atoms/icons/down-arrow';
import AboutAuthor from '../../../story/authors/aboutAuthor';
import StockDetails from '../../../molecules/stock-details';
import { CloseIcon } from '../../../atoms/material-icons';

const SearchResults = ({ searchTerm }) => {
  const resultsInputRef = useRef();

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);

  const [allOffset, setAllOffset] = useState(0);
  const [textOffset, setTextOffset] = useState(0);
  const [videoOffset, setVideoOffset] = useState(0);
  const [reportsOffset, setReportsOffset] = useState(0);
  const [stockOffet, setStockOffset] = useState(15);

  const [allTotal, setAllTotal] = useState(0);
  const [textTotal, setTextTotal] = useState(0);
  const [videoTotal, setVideoTotal] = useState(0);
  const [reportsTotal, setReportsTotal] = useState(0);
  const [stocksToal, setStocksTotal] = useState(0);

  const [allStories, setAllStories] = useState([]);
  const [textStories, setTextStories] = useState([]);
  const [videoStories, setVideoStories] = useState([]);
  const [researchReports, setResearchReports] = useState([]);
  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    fetchMoreAllStories();
    fetchMoreTextStories();
    fetchMoreVideoStories();
    fetchMoreResearchReports();
    fetchStocksData();
  }, []);

  let authors;

  if (textStories) {
    const uniqueAuthors = [];
    const AllAuthors = [...textStories, ...videoStories, ...researchReports].map(
      (story) => story.authors[0]
    );

    AllAuthors.forEach((author) => {
      var i = uniqueAuthors.findIndex((x) => x.name == author.name);
      if (i <= -1) {
        uniqueAuthors.push(author);
      }
    });

    authors = uniqueAuthors;
  }

  const fetchStocksData = () => {
    fetch(`https://www.ndtvprofit.com/stock_search?q=${searchTerm}`)
      .then((res) => res.json())
      .then((res) => {
        setStocks(res);
        setStocksTotal(res.length);
      })
      .catch((error) => error);
  };

  const fetchMoreAllStories = () => {
    setLoading(true);
    fetch(
      `/api/v1/advanced-search?q=${searchTerm}&limit=15&offset=${allOffset}&sort=latest-published`
    )
      .then((res) => res.json())
      .then((res) => {
        setAllStories((allStories) => [...allStories, ...res.items]);
        setAllOffset((allOffset) => allOffset + 15);
        setAllTotal(res.total);
        setLoading(false);
      })
      .catch((error) => error);
  };

  const fetchMoreTextStories = () => {
    setLoading(true);
    fetch(
      `/api/v1/advanced-search?q=${searchTerm}&limit=15&type=text,syndicated&exclude-section-id=21615&offset=${textOffset}&sort=latest-published`
    )
      .then((res) => res.json())
      .then((res) => {
        setTextStories((textStories) => [...textStories, ...res.items]);
        setTextOffset((textOffset) => textOffset + 15);
        setTextTotal(res.total);
        setLoading(false);
      })
      .catch((error) => error);
  };

  const fetchMoreVideoStories = () => {
    setLoading(true);
    fetch(
      `/api/v1/advanced-search?q=${searchTerm}&limit=15&type=video&offset=${videoOffset}&sort=latest-published`
    )
      .then((res) => res.json())
      .then((res) => {
        setVideoStories((videoStories) => [...videoStories, ...res.items]);
        setVideoOffset((videoOffset) => videoOffset + 15);
        setVideoTotal(res.total);
        setLoading(false);
      })
      .catch((error) => error);
  };

  const fetchMoreResearchReports = () => {
    setLoading(true);
    fetch(
      `/api/v1/advanced-search?q=${searchTerm}&limit=15&section-id=21615&offset=${reportsOffset}&sort=latest-published`
    )
      .then((res) => res.json())
      .then((res) => {
        setResearchReports((researchReports) => [...researchReports, ...res.items]);
        setReportsOffset((reportsOffset) => reportsOffset + 15);
        setReportsTotal(res.total);
        setLoading(false);
      })
      .catch((error) => error);
  };

  const clearInput = () => {
    resultsInputRef.current.value = '';
  };

  const tabs = [
    { name: 'All', total: allTotal },
    { name: 'Stories', total: textTotal },
    { name: 'Videos', total: videoTotal },
    { name: 'Reports', total: reportsTotal },
    { name: 'Authors', total: authors?.length },
    { name: 'Stocks', total: stocksToal },
  ];

  return (
    <div styleName="search-result-container">
      <div styleName="search-result-search">
        <SearchIcon fontSize="15px" color="regent-gray" />
        <form action="/search" method="get" styleName="form-ctx">
          <input
            ref={resultsInputRef}
            name="q"
            type="search"
            autoComplete="off"
            variant="primary"
            placeholder="Search Stories, Videos, Reports & more"
            defaultValue={searchTerm}
            styleName="form-input"
          />
          <div styleName="close-icon" onClick={clearInput}>
            <CloseIcon />
          </div>
          <div styleName="enter-to-search">
            <span>Enter </span>
            <small>to Search</small>
            <button styleName="search-icon-black-bg" type="submit">
              <SearchIcon fontSize="16px" color="white" />
            </button>
          </div>
        </form>
        <div styleName="white-shadow" />
      </div>
      <div styleName="search-result-tabs">
        {tabs.map((tab, index) => (
          <button
            onClick={() => setActiveTab(index)}
            styleName={activeTab === index ? 'active' : ''}
          >
            {tab.name}
            <span>{` (${tab.total})`}</span>
          </button>
        ))}
      </div>
      <div
        styleName="search-results-list"
        style={{
          transform: `translateX(-${activeTab * (100 / tabs?.length)}%)`,
          width: `${tabs?.length * 100}%`,
        }}
      >
        <div
          styleName="text-stories-section"
          style={{ maxHeight: activeTab === 0 ? 'min-content' : '10px' }}
        >
          <div>
            {allStories &&
              allStories.map((story) => (
                <CardWithAuthorDateTimeHeadline story={story} showSection={true} />
              ))}
          </div>
          {allTotal > allOffset ? (
            !loading ? (
              <Button
                label="More Stories"
                rounded="full"
                variant="outline"
                styleName="view-all-large"
                icon="right"
                onClick={fetchMoreAllStories}
              >
                <DownArrow />
              </Button>
            ) : (
              <div styleName="loading-container">
                <div styleName="loading" />
              </div>
            )
          ) : null}
        </div>

        <div
          styleName="text-stories-section"
          style={{ maxHeight: activeTab === 1 ? 'min-content' : '10px' }}
        >
          <div>
            {textStories &&
              textStories.map((story) => (
                <CardWithAuthorDateTimeHeadline story={story} showSection={true} />
              ))}
          </div>
          {textTotal > textOffset ? (
            !loading ? (
              <Button
                label="More Stories"
                rounded="full"
                variant="outline"
                styleName="view-all-large"
                icon="right"
                onClick={fetchMoreTextStories}
              >
                <DownArrow />
              </Button>
            ) : (
              <div styleName="loading-container">
                <div styleName="loading" />
              </div>
            )
          ) : null}
        </div>

        <div
          styleName="video-stories-section"
          style={{ maxHeight: activeTab === 2 ? 'min-content' : '10px' }}
        >
          <div>
            {videoStories &&
              videoStories.map((story) => (
                <CardWithAuthorDateTimeHeadline story={story} isPlayIcon={true} showAuthor={true} />
              ))}
          </div>
          {videoTotal > videoOffset ? (
            !loading ? (
              <Button
                label="More Videos"
                rounded="full"
                variant="outline"
                styleName="view-all-large"
                icon="right"
                onClick={fetchMoreVideoStories}
              >
                <DownArrow />
              </Button>
            ) : (
              <div styleName="loading-container">
                <div styleName="loading" />
              </div>
            )
          ) : null}
        </div>

        <div
          styleName="research-reports-section"
          style={{ maxHeight: activeTab === 3 ? 'min-content' : '10px' }}
        >
          <div>
            {researchReports &&
              researchReports.map((story) => (
                <CardWithAuthorDateTimeHeadline story={story} showAuthor={true} />
              ))}
          </div>
          {reportsTotal > reportsOffset ? (
            !loading ? (
              <Button
                label="More Reports"
                rounded="full"
                variant="outline"
                styleName="view-all-large"
                icon="right"
                onClick={fetchMoreResearchReports}
              >
                <DownArrow />
              </Button>
            ) : (
              <div styleName="loading-container">
                <div styleName="loading" />
              </div>
            )
          ) : null}
        </div>

        <div
          styleName="authors-section"
          style={{ maxHeight: activeTab === 4 ? 'min-content' : '10px' }}
        >
          {authors &&
            authors.map((author) => {
              if (!author.bio) {
                author.bio = '- -';
              }
              return (
                <AboutAuthor
                  authorDetails={author}
                  showSocials={false}
                  desktopCharLimit={80}
                  truncateBio={false}
                />
              );
            })}
        </div>

        <div
          styleName="stocks-section"
          style={{ maxHeight: activeTab === 5 ? 'min-content' : '10px' }}
        >
          {stocks && stocks.slice(0, stockOffet).map((stock) => <StockDetails stock={stock} />)}
          {stocks && stocks?.length > stockOffet ? (
            <Button
              label="More Stocks"
              rounded="full"
              variant="outline"
              styleName="view-all-large"
              icon="right"
              onClick={() => setStockOffset((stockOffet) => stockOffet + 15)}
            >
              <DownArrow />
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SearchResults;
